export const sidebarNavs =[{"name":"Menu","type":"section"}]
export const horizontalDefaultNavs = [{"name":"Menu","type":"section"}]
export const minimalHorizontalMenus = [{"name":"Menu","type":"section"}]
